<template>
  <div class="agree">
    <p>生效及更新日期：2026年04月14日</p>
    <p>厦门默往科技有限公司（以下简称"我们"）深知个人信息对您的重要性，并会尽力保护您的个人信息安全可靠，我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则，目的明确原则，选择同意原则，最少够用原则，确保安全原则，主体参与原则，公开透明原则等等。同时我们承诺，我们将按业界成熟的安全解决方案，采取相应的安全保护措施来保护您的个人信息。鉴此，我们制定本《默往隐私权政策》（下称"本政策 /本隐私权政策"）并提醒您：</p>
    <p>本政策适用于默往产品或服务。如我们关联公司的产品或服务中使用了默往提供的产品或服务（例如直接使用默往账户登录）但未设独立隐私权政策的，则本政策同样适用于该部分产品或服务。</p>
    <p>需要特别说明的是，本政策不适用于其他第三方向您提供的服务，也不适用于默往中已另行独立设置隐私权政策的产品或服务。</p>
    <p>在使用默往各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用默往各项产品或服务，即表示您已充分理解并同意本政策。如对本政策内容有任何疑问、意见或建议，您可通过默往提供的各种联系方式与我们联系。</p>
    <p>本隐私权政策部分将帮助您了解以下内容：</p>
    <p><b>1、我们如何收集和使用您的个人信息<br/>
    2、我们如何使用 Cookie 和同类技术<br/>
    3、我们如何共享、转让、公开披露您的个人信息<br/>
    4、我们如何保护您的个人信息<br/>
    5、您如何管理您的个人信息<br/>
    6、我们如何处理未成年人的个人信息<br/>
    7、您的个人信息如何在全球范围转移<br/>
    8、本隐私权政策如何更新<br/>
    9、如何联系我们</b></p>

    <p><b>一、我们如何收集和使用您的个人信息</b></p>
    <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，我们会出于本政策所述的以下目的，收集和使用您的个人信息：</p>

    <p><b>（一）帮助您成为我们的用户</b></p>
    <p>为完成创建账号，以便我们为您提供服务，您需要提供以下信息：您的昵称、头像、性别、出生年月日、手机号码、短信验证码，并创建用户名和密码。</p>
    <p>在注册过程中，如果您提供以下额外信息补全个人资料，将有助于我们给您提供更好的服务和体验同时也是为了满足相关法律法规的真实身份信息认证要求：您的真实姓名、真实证件信息、您本人的真实头像。但如果您不提供这些信息，将不会影响使用默往产品或服务的基本功能。</p>
    <p>您提供的上述信息将在您使用本服务期间持续授权我们使用。</p>
    <p>上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。</p>

    <p><b>（二）向您提供服务</b></p>
    <p><b>1、您向我们提供的信息</b></p>
    <p>您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件、银行卡号或支付宝账号等；</p>
    <p>您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。向默往提供该其他方的前述个人信息之前，您需确保您已经取得其授权同意。</p>
    <p><b>2、我们在您使用服务过程中收集的手机信息和手机权限及手机存储说明</b></p>
    <p>为向您提供更契合您需求的页面展示和服务、了解产品适配性、识别账号异常状态，我们会根据业务场景、您的授权收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，同时为了保障软件与服务的安全运行，防止您的个人信息被非法获取，更准确的预防欺诈和保护账户安全，这些信息包括：</p>
    <p>设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息或软件信息,例如设备型号、设备序列号、操作系统版本、设备设置、设备标识符（IMEI/Android ID/OAID/IDFA/IDFV/UDID/SIM卡IMSI信息等）、设备硬件地址MAC、设备传感器数据，获取传感器信息、读取<b>SD卡上的数据、修改/删除SD卡上的数据、</b>设备应用安装列表等软硬件特征信息、设备所在位置相关信息（例如IP 地址、GPS位置以及能够提供相关信息的Wi-Fi 接入点、蓝牙和基站等传感器信息，因我们提供的服务内容包含你所在地的天气信息，您确认成功注册"默往"帐号视为确认授权我们提取、公开及使用您的地理位置信息、<b>获取精准位置。</b>如果需要终止向默往提供精准位置，可以随时关闭精准位置（GPS）的授权。</p>
    <p><b>日志信息：</b>当您使用我们的客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间等。</p>
    <p><b>手机相册访问权限：</b>当您使用我们的客户端提供的产品或服务时，我们会收集经过您授权同意的手机相册访问权限，应用于扫一扫获取相册图片和保存图片、发送图片、上传头像、更好头像的功能，但如果您不允许提供这些信息，将不会影响使用本产品的基本功能。</p>
    <p>自启动和关联启动说明：</p>
    <p>①为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用(自启动)能力，将存在一定频率通过 系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。</p>
    <p>②为了给您带来更好的语音通话功能体验，当您接收到语音通话时，我们会发送推送通知给您，若在您接通语音通话的过程中同时接起手机本地通话的，我们将会对语音通话做挂断处理。为了实现此功能所以我们注册了对手机通话状态的检测，因此关联了自启动功能；</p>
    <p>③在您未同意用户协议和隐私政策前，我们不会有自启动或关联启动。</p>
    <p>④com.xiaomi.push.service.receivers.NetworkStatusReceiver</p>
    <p>使用目的：小米推送SDK实现推送功能需要注册的广播；</p>
    <p>小米推送SDK地址：</p>
    <p>https://dev.mi.com/distribute/doc/details?pId=1534</p>

    <p><b>读取剪贴板：当您使用我们的客户端提供的产品或服务时，为提升跨应用操作体验，本应用可能读取剪贴板中的分享链接或群口令，仅用于本地内容匹配，不会存储或上传。您可在手机设置中随时关闭此权限。</b></p>

    <p><b>麦克风录音权限：</b>当您使用我们的客户端提供的产品或服务时，我们会收集经过您授权同意的手机麦克风录音权限，应用于录制语音、发送语音消息的功能，但如果您不允许提供这些信息，将不会影响使用本产品的基本功能。</p>
    <p><b>银行卡身份证认证信息：</b>当您使用我们的客户端提供的产品或服务时，我们会收集经过您授权同意填写的银行卡信息和身份证认证信息，应用于充值、支付等功能，但如果您不允许提供这些信息，将不会影响使用本产品的基本功能。</p>
    <p>摄像头访问权限：当您使用我们的客户端提供的产品或服务时，我们会收集经过您授权同意的手机摄像头访问权限，应用于拍摄、拍照等功能，但如果您不允许提供这些信息，将不会影响使用本产品的基本功能。</p>
    <p><b>通知权限：</b>当您使用我们的客户端提供的产品或服务时，我们会收集经过您授权同意的手机通知权限，应用于接收消息提醒的功能，但如果您不允许提供这些信息，将不会影响使用本产品的基本功能。</p>
    <p><b>用户账户注销权限：</b>当您不适用我们的客户端提供的产品或服务时，您可以在【我】-【设置】-【安全】-【账户安全中心】-【注销账号】进行申请账号注销，根据规则进行申请，审核通过即可注销账号。</p>
    <p>请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</p>
    <p>请您理解，为动态检测您的账户是否存在异常，您把本软件切换至后台或重新启动程序时，我们可能会再次读取，我们将读取频次控制在合理的范围内。</p>
    <p>当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>

    <p><b>（三）为您提供安全保障</b></p>
    <p>为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或默往相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息、有关网络日志以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>

    <p><b>（四）引入友盟SDK统计服务开展内部数据分析和研究，改善我们的产品或服务</b></p>
    <p>我们收集数据是根据您与我们的互动和您所做出的选择，包括您的隐私设置以及您使用的产品和功能。我们收集唯一设备识别码（IMEI/Mac/Android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI信息）、设备序列号、安装列表、你安装的应用信息或运行中的进程信息。以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。</p>
    <p>除上述个人信息外，统计分析服务将根据统计维度的不同采集如下信息：SDK/API/JS代码版本、浏览器、互联网服务提供商、IP地址、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、iOS广告标识符（IDFA)、安卓广告主标识符、网卡（MAC）地址、国际移动设备识别码（IMEI）、设备型号、设备MAC地址、设备应用安装列表、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。</p>
    <p>当我们要将信息用于本策略未载明的其它用途时，会事先征求您的同意。</p>
    <p>当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
    <p>友盟SDK隐私权政策链接：<a href="https://www.umeng.com/page/policy" style="text-decoration:underline">https://www.umeng.com/page/policy</a></p>
    <p>您可通过友盟SDK隐私政策链接<a href="https://www.umeng.com/page/policy" style="text-decoration:underline">https://www.umeng.com/page/policy</a>了解关于友盟SDK统计服务采集用户数据的范围及方法。</p>

    <p><b>（五）其他用途</b></p>
    <p>我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>

    <p><b>（六）征得授权同意的例外</b></p>
    <p>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：<br/>
    1、与国家安全、国防安全有关的；<br/>
    2、与公共安全、公共卫生、重大公共利益有关的；<br/>
    3、与犯罪侦查、起诉、审判和判决执行等有关的；<br/>
    4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；<br/>
    5、所收集的个人信息是您自行向社会公众公开的；<br/>
    6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；<br/>
    7、根据您的要求签订合同所必需的；<br/>
    8、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br/>
    9、为合法的新闻报道所必需的；<br/>
    10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br/>
    11、法律法规规定的其他情形。</p>
    <p>如我们停止运营默往产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</p>

    <p><b>二、我们如何使用 Cookie 和同类技术</b></p>
    <p><b>（一）Cookie</b></p>
    <p>为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好等数据。</p>
    <p><b>（二）站信标和像素标签</b></p>
    <p>除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</p>

    <p><b>三、我们如何共享、转让、公开披露您的个人信息</b></p>
    <p>（一）共享</p>
    <p>我们不会与默往服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：<br/>
    1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
    <p>2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。<br/>
    3、与关联公司间共享：为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息或保护默往关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您使用默往账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账户信息），如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。<br/>
    4、与授权合作伙伴共享：仅为实现本隐私权政策中声明的目的，我们的某些服务将由我们和授权合作伙伴共同提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。</p>
    <p>5、为了您能够使用默往服务及功能，我们的应用中会接入第三方SDK，第三方SDK目录：</p>

    <p><b>小米推送SDK</b><br/>
    <b>SDK类型：推送类</b><br/>
    <b>SDK开发者：北京小米移动软件有限公司</b><br/>
    <b>使用目的：用于在小米设备上推送消息</b><br/>
    <b>收集个人信息类型：设备标识符IMEINMEIDAndroidID\ OAID、BSSID\SSID、设备序列码、正在运行的应用列表、存储信息</b><br/>
    <b>小米推送SDK隐私政策链接：https://dev.mi.com/console/doc/detail?pId=1822</b></p>

    <p><b>华为推送SDK</b><br/>
    <b>SDK类型：推送类</b><br/>
    <b>SDK开发者：华为软件技术有限公司</b><br/>
    <b>使用目的：用于在华为设备上推送消息</b><br/>
    <b>收集个人信息类型：设备标识信息(设备标识码IMEI AndroidlD、BSSIDISSID、MCCIMNC、WIFI信息、设备序列码)、正在运行的应用列表、目录文件</b><br/>
    <b>华为推送SDK隐私政策链接：</b><br/>
    <b>https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177</b></p>

    <p><b>魅族推送SDK</b><br/>
    <b>SDK类型：推送类</b><br/>
    <b>SDK开发者：珠海星纪魅族信息技术有限公司</b><br/>
    <b>使用目的：用于在魅族设备上推送消息</b><br/>
    <b>收集个人信息类型：设备标识信息（设备标识符IMEIMEIDMAC地址、BSSIDISSID、MCCIMNC、设备序列码、WIFI列表、正在运行的应用列表)、位置信息、存储目录、网络状态信息、运营商信息</b><br/>
    <b>魅族推送SDK隐私政策链接：https://open.flyme.cn/docs?id=202</b></p>

    <p><b>VIVO推送SDK</b><br/>
    <b>SDK类型：推送类</b><br/>
    <b>SDK开发者：维沃移动通信有限公司</b><br/>
    <b>使用目的：用于在VIVO设备上推送消息</b><br/>
    <b>收集个人信息类型：设备标识信息(OAID、正在运行的应用列表、正在运行的应用程序信息)、网络状态信息</b><br/>
    <b>vivo推送SDK隐私政策链接：https://dev.vivo.com.cn/documentCenter/doc/652</b></p>

    <p><b>OPPO推送SDK</b><br/>
    <b>SDK类型：推送类</b><br/>
    <b>SDK开发者：广东欢太科技有限公司</b><br/>
    <b>使用目的：用于在oppo设备上推送消息</b><br/>
    <b>收集个人信息类型: 设备相关信息（如IMEI或OAID，Serial Number，IMSI，User ID，Android ID，Google Advertising ID, 手机Region设置，设备型号，手机电量，手机操作系统版本及语言）、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果、通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知）。</b><br/>
    <b>OPPO推送SDK隐私政策链接：</b><br/>
    <b>https://open.oppomobile.com/new/developmentDoc/info?id=11228</b></p>

    <p><b>友盟+社会化分享SDK</b><br/>
    <b>SDK类型：社交类</b><br/>
    <b>SDK开发者：友盟同欣(北京)科技有限公司</b><br/>
    <b>使用目的：消息分享</b><br/>
    <b>收集个人信息类型:设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM 卡 IMSI 信息等）、设备序列号、应用运行中的进程信息</b><br/>
    <b>友盟+社会化分享SDK隐私政策链接：https://www.umeng.com/page/policy</b></p>

    <p><b>友盟+移动统计SDK</b><br/>
    <b>SDK类型：统计类</b><br/>
    <b>SDK开发者：友盟同欣(北京)科技有限公司</b><br/>
    <b>使用目的：移动统计分析</b><br/>
    <b>收集个人信息类型:设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM 卡 IMSI 信息等）、设备序列号、应用运行中的进程信息</b><br/>
    <b>友盟+移动统计SDK隐私政策链接：https://www.umeng.com/page/policy</b></p>

    <p><b>网易易盾号码认证SDK</b><br/>
    <b>SDK类型：第三方登录类</b><br/>
    <b>SDK开发者：杭州网易质云科技有限公司</b><br/>
    <b>使用目的：用于集成移动,电信,联通号码一键登录功能</b><br/>
    <b>收集个人信息类型: 本机电话号码、IP地址、网卡（MAC)地址、国际移动设备识别码（IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志</b><br/>
    <b>网易易盾号码认证SDK隐私政策链接：https://dun.163.com/clause/privacy</b></p>

    <p><b>微信SDK</b><br/>
    <b>SDK类型：第三方登录类</b><br/>
    <b>SDK开发者：深圳市腾讯计算机系统有限公司</b><br/>
    <b>使用目的：分享、授权登录、微信支付</b><br/>
    <b>收集个人信息类型: 设备型号、操作系统、唯一设备标识符（Android端如AndroidID/OAID）</b><br/>
    <b>微信隐私政策链接：</b><br/>
    <b>https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</b></p>

    <p><b>腾讯浏览服务</b><br/>
    <b>SDK类型：框架类</b><br/>
    <b>SDK开发者：深圳市腾讯计算机系统有限公司</b><br/>
    <b>使用目的：优化用户的应用内网页浏览体验</b><br/>
    <b>收集个人信息类型：设备标识信息（Android_ID、IMSI）、应用运行中的进程信息</b><br/>
    <b>腾讯浏览服务X5网页引擎 SDK隐私政策链接：</b><br/>
    <b>https://rule.tencent.com/rule/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d</b></p>

    <p><b>首信易支付</b><br/>
    <b>SDK开发者：易智付科技（北京）有限公司</b><br/>
    <b>使用目的：支持用户在应用内使用首信易支付</b><br/>
    <b>收集个人信息类型：身份信息、联系方式、银行卡信息、应用内交易信息、应用运行中的进程信息</b><br/>
    <b>官网链接：http://www.beijing.com.cn/2.0</b></p>

    <p><b>声网SDK</b><br/>
    <b>SDK类型：实时音视频类</b><br/>
    <b>SDK开发者：上海声网科技有限公司</b><br/>
    <b>使用目的：视频通话</b><br/>
    <b>收集个人信息类型：相机、麦克风</b><br/>
    <b>声网SDK隐私政策链接：https://www.shengwang.cn/SDK-privacy-policy/</b></p>

    <p><b>GVoice SDK</b><br/>
    <b>SDK类型：实时音视频类</b><br/>
    <b>SDK开发者：深圳市腾讯计算机系统有限公司</b><br/>
    <b>使用目的：语音通话</b><br/>
    <b>收集个人信息类型：麦克风</b><br/>
    <b>GVoice SDK隐私政策链接：</b><br/>
    <b>https://gcloud.tencent.com/pages/documents/details.html?projectId=256&amp;docId=3118&amp;from_wecom=1</b></p>

    <p><b>OAID SDK</b><br/>
    <b>使用目的：移动联盟广告标识</b><br/>
    <b>收集个人信息类型：设备标识信息</b><br/>
    <b>隐私权政策链接：https://msa-alliance.cn/col.jsp?id=122</b></p>

    <p><b>阿里云OSS SDK</b><br/>
    <b>使用目的：用于存储用户消息相关语音视频图片文件</b><br/>
    <b>收集个人信息类型：存储</b><br/>
    <b>隐私权政策链接：</b><br/>
    <b>http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.7933691.7y9jhqsfz.86.43692a66otvjJe</b></p>

    <p><b>七牛云存储 SDK</b><br/>
    <b>SDK类型：存储类</b><br/>
    <b>SDK开发者：上海七牛信息技术有限公司</b><br/>
    <b>使用目的：存储用户消息文件数据</b><br/>
    <b>收集个人信息类型：存储、网络状态信息</b><br/>
    <b>七牛云存储 SDK隐私政策链接：https://www.qiniu.com/agreements/privacy-right</b></p>

    <p><b>bugly SDK</b><br/>
    <b>SDK类型：性能监控类</b><br/>
    <b>SDK开发者：深圳市腾讯计算机系统有限公司</b><br/>
    <b>使用目的：收集上报应用错误崩溃日志</b><br/>
    <b>收集个人信息类型：日志信息（包括：第三方开发者自定义 日志、Logcat 日志以及 APP 崩溃堆栈信息）、设备 ID（包括：androidid 以及 idfv）、联网信息、系统名称、系统版本以及国家码。</b><br/>
    <b>bugly SDK隐私政策链接：</b><br/>
    <b>https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</b></p>

    <p><b>Crash SDK</b><br/>
    <b>SDK类型：性能监控类</b><br/>
    <b>SDK开发者：广州市动景计算机科技有限公司</b><br/>
    <b>使用目的：崩溃监测与性能监测</b><br/>
    <b>收集个人信息类型：设备信息（UUID、设备品牌、设备型号、设备ROM版本）、网络信息（IP地址、网络类型、网络状态）、时间戳、应用信息（应用包名、应用版本号）、开发者主动上传的数据（自定义标识、日志）</b><br/>
    <b>Crash SDK隐私政策链接：https://yueying-docs.effirst.com/privacy.html</b></p>

    <p><b>上海领页SDK</b><br/>
    <b>SDK类型：广告类</b><br/>
    <b>SDK开发者：上海领页信息科技有限公司</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围:设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息(mcc&amp;mnc)、CPU信息、可用存储空间大小等基础信息、AndroidID、OAID、手机系统重启时间、磁盘总空间、系统总内存空间、IDFV、设备MAC地址、设备标识符(如IMEI、IMSI、GAID(仅GMS服务)、MEID、硬件序列号build serial，设备标识符(如IDFA）；运营商信息、Wi-Fi状态、网络信号强度、IP地址；应用包名、运行中的进程信息、版本号、应用前后台状态；软件列表信息；线性加速度传感器、磁场传感器旋转矢量传感器、加速度传感器、陀螺仪传感器；对广告的展示、点击及转化等交互数据；精确位置信息、粗略位置信息(WiFi列表、WLAN接入点(如SSID，BSSID)、基站)；如崩溃数据、性能数据；</b><br/>
    <b>使用目的：广告投放及广告反作弊。其中，IMEI、IDFA、 AndroidID、OAID、设备的MAC地址、设备型号还会用于广告监测归因。保证网络服务有效性及稳定性其中，运营商信息、Wi-Fi状态还会用于广告投放IP地址用于广告投放、广告监测归因、广告反作弊。摇一摇、扭一扭等广告投放、广告反作弊；广告监测归因、广告投放统计分析、广告反作弊；广告定向投放及广告反作弊；减少App崩溃、提供稳定可靠的服务</b><br/>
    <b>上海领页SDK隐私政策链接：https://manage.shanghailingye.cn/privacy</b></p>

    <p><b>穿山甲广告SDK</b><br/>
    <b>SDK类型：广告类</b><br/>
    <b>SDK开发者：北京巨量引擎网络技术有限公司</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围：设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&amp;mnc）、CPU信息、可用存储空间大小等基础信息、OAID、AndroidID、手机系统重启时间、磁盘总空间、系统总内存空间、IDFV、ODID、设备MAC地址、设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、硬件序列号build_serial，具体字段因软硬件版本不同而存在差异）、设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）、运营商信息、Wi-Fi状态、网络信号强度、IP地址、应用包名、运行中的进程信息、版本号、应用前后台状态、软件列表信息、线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器、对广告的展示、点击及转化等交互数据、精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID，BSSID）、基站、如崩溃数据、性能数据</b><br/>
    <b>隐私政策链接：https://www.csjplatform.com/privacy</b></p>

    <p><b>优量汇SDK</b><br/>
    <b>SDK类型：广告类</b><br/>
    <b>SDK开发者：深圳市腾讯计算机系统有限公司</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围：粗略位置信息、基站、附近的WIFI、连接的WIFI、精确位置信息<br/>
    设备/网络/系统信息、设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商、磁力、加速度、重力、陀螺仪传感器、设备名称、系统启动时间、系统语言、磁盘空间、设备姿态、压力传感器等基础信息<br/>
    标识符、OAID、IMEI（Device ID）、Android_ID、IDFV、 IDFA、应用的包名、版本号、应用的进程名称、运行状态、可疑行为、应用安装信息、使用数据、如产品交互数据、广告数据（如展示、点击、转化广告数据）、如崩溃数据、性能数据</b><br/>
    <b>隐私政策链接：</b><br/>
    <b>https://qzs.gdtimg.com/union/res/union_cdn/page/dev_rules/ylh_sdk_privacy_statement.html</b></p>

    <p><b>百度SDK</b><br/>
    <b>SDK类型：广告类</b><br/>
    <b>SDK开发者：北京百度网讯科技有限公司</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围：设备信息、设备品牌、型号、软件系统版本、分辨率、网络信号强度、磁盘总空间、系统内存空间、屏幕宽高，屏幕像素密度，系统版本号，设备厂商，设备型号，手机运营商、SIM卡信息、手机重启信息、手机系统更新时间、手机系统创建时间、IDFA（仅iOS端采集）、OAID等基础信息、IMEI（仅Andriod端采集）；传感器信息（使用摇一摇等创新交互广告）；网络状态（判断网络状态、提供不同类型广告）、应用信息：应用包名、应用签名、版本号、应用前后台状态、运行进程信息；软件列表信息（仅Android端采集）、位置信息；操作记录、点击、展示、转化等交互数据、性能数据、崩溃数据、性能数据</b><br/>
    <b>隐私政策链接：https://union.baidu.com/bqt/#/legal/policies</b></p>

    <p><b>快手联盟广告SDK</b><br/>
    <b>SDK类型：广告类</b><br/>
    <b>SDK开发者：北京快手广告有限公司</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围：基础信息必要信息【双端】设备品牌、设备型号、软件系统版本、存储信息、设备时区、设备语言、网络信息、可用存储空间大小、CPU信息、屏幕密度、屏幕分辨率等基础信息广告投放、广告归因、反作弊、安全【鸿蒙】设备品牌、设备型号、系统版本、CPU信息、屏幕密度，屏幕分辨率等基础信息设备标识必要信息【仅Android】AndroidID、OAID【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、IDFV广告投放、广告归因、反作弊、安全【仅鸿蒙】OAID可选信息【仅Android】设备标识符(IMEI、IMSI、ICCID）、设备IP【仅iOS】设备标识符（IDFA)快手联盟SDK广告投放合作位置信息可选信息【双端】精确位置信息（GPS）、粗略位置广告投放信息（WiFi信息、WLAN接入点（如SSID,BSSID）、基站信息）、IP地址、MAC地址【鸿蒙】精确位置信息（GPS）、粗略位置信息应用信息可选信息广告投放【仅Android】 应用安装列表其他信息必要信息广告投放【双端】陀螺仪传感器、加速度传感器、sim卡激活信息【鸿蒙】传感器信息相关系统权限申请用途和目的可选信息广告投放【仅Android】 读写存储权限</b><br/>
    <b>隐私政策链接：https://u.kuaishou.com/home/detail/1220</b></p>

    <p><b>sigmob sdk</b><br/>
    <b>SDK类型：广告类</b><br/>
    <b>SDK开发者：北京创智汇聚科技股份有限公司</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围：位置信息、粗略位置信息、精确位置信息 个性化广告推荐、反作弊；传感器信息 ；传感器开关：线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器 反作弊；摇一摇、扭一扭等互动广告投放标识符 ；IMEI （Device ID）、Android_ID、OAID（具体字段因软硬件版本不同而存在差异） 广告投放、广告归因、广告监测、反作弊；应用信息 、应用的包名、应用版本号；应用安装列表 广告投放、反作弊；广告归因；避免重复安装设备／系统信息、设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、时区、设备语言、国家代码、总磁盘大小、剩余磁盘大小、运行内存、前后台状态、运行中的进程信息、sim卡信息（mcc＆mnc）、锁屏状态 用于推送与设备适配的广告内容、反作弊网络信息 、IP地址、网络类型；运营商 广告投放、反作弊行为数据、产品交互数据、广告数据（如展示、点击、转化数据） 广告投放、广告归因诊断数据 、崩溃数据</b><br/>
    <b>隐私政策链接：</b><br/>
    <b>https://doc.sigmob.com/Sigmob%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97/%E5%90%88%E8%A7%84%E6%9D%A1%E6%AC%BE/%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/</b></p>

    <p><b>Taku Android SDK</b><br/>
    <b>SDK类型：广告类</b><br/>
    <b>SDK开发者：广州塔酷信息科技有限公司</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围：【Android+iOS+HarmonyOS】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&amp;mnc）、限制广告追踪（LAT）状态、CPU信息、可用存储空间大小等基础信息【Android】Android ID、OAID【iOS】：手机系统重启时间、磁盘总空间、系统总内存空间、IDFV【HarmonyOS】ODID【Android+iOS+HarmonyOS】CPU类型、设备电池电量信息、设备音量及字体大小、是否为模拟器、是否usb链接、是否开发者模式、系统启动程序版本号、硬件名称，主机地址，系统开发代号、系统源码控制版本号、设备显示的版本号、设备基板名称【Android+HarmonyOS】：国际移动设备识别码（IMEI）、MAC地址、国际移动用户识别码（IMSI）【Android】硬件序列号build_serial，具体字段因软硬件版本不同而存在差异）【iOS】：设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）【HarmonyOS】：OAID【Android+iOS+HarmonyOS】运营商信息、Wi-Fi状态、网络信号强度【Android+iOS+HarmonyOS】IP地址【Android+HarmonyOS】Taku 合作方的应用包名、运行中的进程信息、版本号、应用前后台状态、SDK 版本号【Android】软件列表信息，是否为应用商店下载【Android】线性加速度传感器【iOS+HarmonyOS】加速度传感器、陀螺仪传感器【Android+iOS+HarmonyOS】对广告的展示、点击及转化等交互数据【Android+HarmonyOS】粗略位置信息（WLAN接入点（如SSID））【Android+iOS+HarmonyOS】如崩溃数据、性能数据</b><br/>
    <b>隐私政策链接：https://help.takuad.com/docs/1Mn1B7</b></p>

    <p><b>奇运sdk</b><br/>
    <b>SDK类型：广告类</b><br/>
    <b>SDK开发者：杭州奇运网络科技有限公司</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围：【双端】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、屏幕背光、sim卡信息（mcc&amp;mnc）、设备语言、设备时区、CPU信息、可用存储空间大小基础信息【仅Android】AndroidID、OAID【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、IDFV【仅Android】设备标识符（如IMEI），具体字段因软硬件版本不同而存在差异）【仅iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）【双端】运营商信息、Wi-Fi状态、网络信号类型【仅Android】应用包名、运行中的进程信息、版本号、应用前后台状态【双端】加速度传感器、陀螺仪传感器</b><br/>
    <b>隐私政策链接：http://ag.xiangshu18.com/jySdkPrivacy.html</b></p>

    <p><b>Fancy SDK</b><br/>
    <b>SDK类型：广告类</b><br/>
    <b>SDK开发者：北京泛为信息科技有限公司</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围：设备信息：【Android】设备型号、系统版本、WIFI权限【iOS】屏幕尺寸、设备型号、系统版本、浏览器UA应用信息：应用包名、版本号信息；其他信息：运营商信息、设备时区、网络权限；【Android】设备IMEI、设备OAID、AndroidId；【双端】加速度传感器、陀螺仪传感器</b><br/>
    <b>隐私政策链接：https://www.fancydigital.com.cn/sdk-privacy</b></p>

    <p><b>移动智能终端补充设备标识体系统一调SDK</b><br/>
    <b>类型：广告类</b><br/>
    <b>SDK开发者：中国信息通信研究院</b><br/>
    <b>使用目的：广告投放合作</b><br/>
    <b>收集的信息范围：获取设备制造商、设备型号、设备品牌，用于判断终端品牌，调用接口；设备网络运营商名称，用于判断是否为虚拟机环境；App包名及签名信息，设备识别码（APNS Token、设备序列号、AndroidID、OAID、GAID、IDFV、CID、MAC地址），或在对应应用商店的APPID，用于生成VAID和判断是否为同一开发者</b><br/>
    <b>隐私政策链接：https://www.msa-alliance.cn/col.jsp?id=122</b></p>

    <p>我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
    <p>6.默往不会主动将您的个人信息共享至无关联、无授权合作的第三方主体，默往中的第三方服务由第三方主体自行提供，第三方主体在经您同意后可以获取您的个人信息，你在使用默往中的第三方服务时应充分了解第三方的产品功能及信息保护策略。</p>

    <p>（二）转让</p>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br/>
    1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<br/>
    2、在涉及合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>

    <p>（三）公开披露</p>
    <p>我们仅会在以下情况下，公开披露您的个人信息：<br/>
    1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；<br/>
    2、如果我们确定您出现违反法律法规或严重违反默往相关协议规则的情况，或为保护默往及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或默往相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及默往已对您采取的措施。</p>

    <p>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
    <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：<br/>
    1、与国家安全、国防安全有关的；<br/>
    2、与公共安全、公共卫生、重大公共利益有关的；<br/>
    3、与犯罪侦查、起诉、审判和判决执行等有关的；<br/>
    4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br/>
    5、您自行向社会公众公开的个人信息；<br/>
    6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
    <p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>

    <p><b>四、我们如何保护您的个人信息安全</b></p>
    <p>（一）我们已采取符合业界通用解决方案、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据（如信用卡信息）时受 SSL（Secure Socket Layer）协议加密保护；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
    <p>（二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。</p>
    <p>（三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内<b>（至少6个月以上）</b>保留您的个人信息，<b>除非法律有强制的存留要求。而我们判断前述期限的标准包括:</b></p>
    <p><b>1、保证我们为您提供服务的安全和质量;</b><br/>
    <b>2、您是否同意更长的留存期间;</b><br/>
    <b>3、是否存在保留期限的其他特别约定。</b><br/>
    <b>在您的个人信息超出保留期间后,我们会根据适用法律的要求删除您的个人信息,或使其匿名化处理。</b></p>
    <p>（四）互联网并非绝对安全的环境，我们强烈建议您不要使用非默往推荐的通信方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。</p>
    <p>如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络默往客服，以便我们根据您的申请采取相应措施。</p>
    <p>请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在发表动态或者在群聊天、圈子等公众场合选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</p>
    <p>请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。</p>
    <p>同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>

    <p><b>五、您如何管理您的个人信息</b></p>
    <p>您可以通过以下方式访问及管理您的个人信息：</p>
    <p>（一）访问您的个人信息</p>
    <p>您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</p>
    <p>账户信息——如果您希望访问或编辑您的账户中的个人证件信息，手机绑定、支付信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过登录账号通过"我"-"设置"-"安全"执行此类操作。</p>
    <p>个人资料—如果您希望访问或编辑您个人资料中的昵称、头像、出生年月日性别其他资料等，您可以通过登录账户通过"我"-"查看或编辑个人资料"执行此类操作。</p>
    <p>如果您无法通过上述路径访问该等个人信息，您可以随时通过默往客服与我们取得联系。我们将在15个工作日内回复您的访问请求。</p>
    <p>对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据本条"（六）响应您的上述请求"中的相关安排向您提供。</p>

    <p>（二）更正或补充您的个人信息</p>
    <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过本条"（一）访问您的个人信息"中列明的方式提出更正或补充申请。</p>

    <p>（三）删除您的个人信息</p>
    <p>您可以通过本条"（一）访问您的个人信息"中列明的方式删除您的部分个人信息。<br/>
    在以下情形中，您可以向我们提出删除个人信息的请求：<br/>
    1、如果我们处理个人信息的行为违反法律法规；<br/>
    2、如果我们收集、使用您的个人信息，却未征得您的明确同意；<br/>
    3、如果我们处理个人信息的行为严重违反了与您的约定；<br/>
    4、如果您不再使用我们的产品或服务；<br/>
    5、如果我们永久不再为您提供产品或服务。</p>
    <p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</p>
    <p>当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>

    <p>（四）改变您授权同意的范围</p>
    <p>每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策"第一条"）。除此之外，对于额外个人信息的收集和使用，您可以在我-设置或与默往客服联系给予或收回您的授权同意（例如，您可以在默往手机APP"我-设置-隐私"中收回您同意其他用户通过手机号码找到您的授权）。</p>
    <p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>

    <p><b>（五）个人信息主体获取个人信息副本。</b></p>
    <p><b>您有权获取您的个人信息副本。在技术可行的前提下，如数据接口已匹配，我们还可以按您的要求，直接将您的个人信息副本传输给您指定的第三方。</b></p>

    <p>（六）束信息系统自动决策</p>
    <p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害默往商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。</p>

    <p>（七）响应您的上述请求</p>
    <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
    <p>我们将在15个工作日内做出答复。如您不满意，还可以通过默往客服发起投诉。</p>
    <p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
    <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br/>
    1、与国家安全、国防安全有关的；<br/>
    2、与公共安全、公共卫生、重大公共利益有关的；<br/>
    3、与犯罪侦查、起诉、审判和执行判决等有关的；<br/>
    4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；<br/>
    5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br/>
    6、涉及商业秘密的。</p>

    <p><b>六、我们如何处理未成年人的个人信息</b></p>
    <p>如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。如您为未成年人的，请您在您父母或监护人的陪同下仔细阅读本隐私政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</p>
    <p>对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>

    <p><b>七、您的个人信息如何在全球范围转移</b></p>
    <p>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：<br/>
    1、法律法规有明确规定；<br/>
    2、获得您的明确授权；<br/>
    3、您通过互联网进行跨境直播/发布动态等个人主动行为。</p>
    <p>针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。</p>

    <p><b>八、本隐私权政策如何更新</b></p>
    <p>我们的隐私权政策可能变更。</p>
    <p>未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。对于重大变更，我们会提供显著的通知（包括我们会通过默往公示的方式进行通知甚至向您提供弹窗提示）。</p>
    <p>本政策所指的重大变更包括但不限于：<br/>
    1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br/>
    2、我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等；<br/>
    3、个人信息共享、转让或公开披露的主要对象发生变化；<br/>
    4、您参与个人信息处理方面的权利及其行使方式发生重大变化；<br/>
    5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br/>
    6、个人信息安全影响评估报告表明存在高风险时。</p>
    <p>我们还会将本隐私权政策的旧版本存档，供您查阅。</p>

    <p><b>九、如何联系我们</b></p>
    <p>您可以通过以下方式与我们联系，我们将在15个工作日内回复您的请求：<br/>
    1、如对本政策内容有任何疑问、意见或建议，您可通过默往客服及默往手机APP中"默往小助手"-"默往客服号"在线客服与我们联系；<br/>
    2、如发现个人信息可能被泄露，您可以通过邮箱：【youqudev@163.com】；电话：【4006008017】投诉举报；<br/>
    3、我们还设立了个人信息保护专职部门，您可以通过与其联系。</p>
    <p>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</p>
  </div>
</template>
<script>
export default {
  name: 'Agree2',
  created() {
    document.title = '默往隐私政策'
  }
}
</script>
<style lang="scss" scoped>
.agree {
  line-height: 1.5;
  padding: 10px;
  font-size: 15px;
}

p {
  font-size: 15px;
}
</style>
